<section class="verify-password-container">
    <section class="verify-items-container" *ngIf="verifyList">
        <ng-container *ngFor="let validation of verifyList">
            <p *ngIf="validation.isEnabled"
            [ngClass]="{'verify-item': validation.state === verify_state.NONE,
                        'verify-item--isInvalid': validation.state === verify_state.INVALID,
                        'verify-item--isValid' : validation.state === verify_state.VALID   
                        }">
                <i class="pi icon verify-icon"
                    [ngClass]="{ 'pi-minus' : validation.state === verify_state.NONE,
                                 'pi-times' : validation.state === verify_state.INVALID,
                                 'pi-check' : validation.state === verify_state.VALID
                               }"></i>
                <label class="verify-description">{{ validation.description }}</label>
            </p>
        </ng-container>
    </section>
</section>
